import React from "react"
import PropTypes from "prop-types"
import autobind from "class-autobind"
import { Dialog, FlatButton, Toggle } from "material-ui"
import strings from "../../localization/strings"

const propTypes = {
    close: PropTypes.func,
    confirm: PropTypes.func,
    unapprovedCount: PropTypes.number,
    exportedCount: PropTypes.number,
    selectedCount: PropTypes.number
}

class ExportAgainPayrollConfirmDialog extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            exportAgain: false
        }
        autobind(this)
    }

    render() {
        const actions = [
            <FlatButton label={strings.CANCEL} primary={false} onClick={this.props.close} />,
            <FlatButton label={strings.OK} primary={true} keyboardFocused={true} onClick={() => this.props.confirm(this.state.exportAgain)} />
        ]

        return (
            <Dialog title={strings.Export_Payroll} actions={actions} modal open>
                {this.props.unapprovedCount > 0 && (
                    <div style={{ color: "rgb(97, 97, 97)", marginBottom: 5 }}>{strings.formatString(strings.X_employee_have_time_that_has_not_yet_been_approved, this.props.unapprovedCount)}</div>
                )}
                {this.props.exportedCount > 0 && (
                    <div style={{ color: "rgb(97, 97, 97)" }}>{strings.formatString(strings.X_employee_payroll_have_already_been_exported, this.props.exportedCount)}</div>
                )}
                <div style={{ marginTop: 30 }}>
                    <div style={{ color: "rgb(97, 97, 97)", fontWeight: "bold" }}>
                        {strings.formatString(strings.Are_you_sure_you_want_to_export_payroll_for_the_X_selected_employees_as_shown_below, this.props.selectedCount)}
                    </div>
                    <ul style={{ marginTop: 5, paddingLeft: 20 }}>
                        {this.props.unapprovedCount > 0 && (
                            <li>
                                <div style={{ color: "rgb(97, 97, 97)" }}>{strings.formatString(strings.Export_X_employees_with_unapproved_time, this.props.unapprovedCount)}</div>
                            </li>
                        )}
                        <li style={{ marginTop: 5 }}>
                            <Toggle
                                toggled={this.state.exportAgain}
                                onToggle={(e, v) => {
                                    this.setState({ exportAgain: v })
                                }}
                                labelPosition="right"
                                label={strings.Include_employees_that_have_already_been_exported}
                            />
                        </li>
                    </ul>
                </div>
            </Dialog>
        )
    }
}

ExportAgainPayrollConfirmDialog.propTypes = propTypes
export default ExportAgainPayrollConfirmDialog
